import React, { FunctionComponent } from 'react'
import FormField from '@components/FormField/FormField'
import { FreeProps } from '../AnswerProps'
import './FreeTextInput.scss'
export const FreeTextInput: FunctionComponent<FreeProps> = ({ question, onSelection, answer }: FreeProps) => {
  let timer: ReturnType<typeof setTimeout>

  const textHandler = (value: string) => {
    // debounce
    if (value === '' || value.includes('_')) return
    clearTimeout(timer)
    timer = setTimeout(() => {
      onSelection(value)
    }, 400)
  }

  return (
    <div className="FreeTextInput">
      <FormField
        placeholder={question.hint}
        onChange={textHandler}
        value={answer as string}
        mask={question.meta?.inputMask}
      />
    </div>
  )
}

export default FreeTextInput
